const content = [
    {
        id: "restaurangbutiker",
        title: "Restaurangbutiker",
        items: [
            {
                id: "kundtjanst-rb",
                title: "Kundtjänst",
                items: [
                    { content: "08-722 28 80", link: "tel:087222880" },
                    { content: "Mån-Tors: 08:00-16:30" },
                    { content: "Fredag/dag före helgdag: 08:00-15:15" },
                    { content: "Lör-Sön/helgdag: STÄNGT" },
                    { content: "butiker@martinservera.se", link: "mailto:butiker@martinservera.se" }
                ]
            },
            {
                id: "bromma",
                title: "Bromma",
                items: [
                    { content: "08-501 622 50", link: "tel:0850162250" },
                    { content: "Mån-Fre: 06:00-20:00" },
                    { content: "Lör-Sön: 08:00-18:00" },
                    { content: "Ranhammarsvägen 10, 168 67 Bromma" }
                ]
            },
            {
                id: "arsta",
                title: "Årsta",
                items: [
                    { content: "08-501 622 00", link: "tel:0850162200" },
                    { content: "Mån-Fre: 06:00-20:00" },
                    { content: "Lör-Sön: 08:00-18:00" },
                    { content: "Sockenvägen 3, 120 40 Årsta" }
                ]
            }
        ]
    },
];

export default content;